export const countyEA = [
  { value: 'currentApproved', text: 'Approved for assistance with this current financial crisis' },
  { value: 'pastApproved', text: 'Approved within past year for other financial crisis' },
  { value: 'currentPending', text: 'Application currently pending' },
  { value: 'pastDenied', text: 'Denied within the past year' },
  { value: 'notEligible', text: 'Not Eligible to apply' },
  { value: 'notApplied', text: 'I have not applied in the past 12 months' }
]

export const COUNTYEA = countyEA.map(item => {
  item.group = 'countyEA'
  return item
})
